import { useTheme } from '@mui/material/styles';

import { Typography, Grid } from '@mui/material';
import Logo from './LogoImage';
const LogoText = () => {
    const theme = useTheme();
    return (
        <Grid container>
            <Grid item sm={12} display="flex" alignItems="center" gap={1}>
                <Logo width="33%" />
                <Grid container display="block">
                    <Grid item>
                        <Typography
                            variant="h6"
                            sx={{ textDecoration: 'none', fontFamily: 'URW DIN BOLD', color: theme.palette.primary.main }}
                        >
                            TLRG
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-5px' }}>
                        <Typography
                            variant="h3"
                            sx={{ textDecoration: 'none', fontFamily: 'URW DIN BOLD', color: theme.palette.primary.main }}
                        >
                            LLN
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-5px' }}>
                        <Typography
                            variant="h2"
                            sx={{ textDecoration: 'none', fontFamily: 'URW DIN BOLD', color: theme.palette.primary.main }}
                        >
                            ROBOT
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LogoText;
